// ** Theme Type Import
import { Theme } from '@mui/material';


const Typography = (theme: Theme) => {
  return {
    h1: {
      fontSize: '1.5rem',
      fontWeight: 400,
    },
    h2: {
      fontSize: '1.375rem',
      fontWeight: 400,
    },
    h3: {
      fontSize: '1.125rem',
      fontWeight: 400,
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '0.75rem',
      fontWeight: 500,
    },
    subtitle1: {
    },
    subtitle2: {
    },
    body1: {
    },
    body2: {
    },
    button: {
    },
    caption: {
    },
    overline: {
    },
  };
};

export default Typography;
